"use client"

import * as React from "react"
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react"
import { DayButton, DayPicker, getDefaultClassNames, type DropdownProps } from "react-day-picker"
import { Button } from "@/components/ui/button"
import { FieldSelect } from './field-select'
import styles from './calendar.module.css'
import { cn } from "@/lib/utils"

function Calendar({ className, classNames, showOutsideDays = true, captionLayout = "label", components, ...props }: React.ComponentProps<typeof DayPicker>) {
  const defaults = getDefaultClassNames()
  return <DayPicker showOutsideDays={showOutsideDays} captionLayout={captionLayout} className={cn(styles.calendar, className)} classNames={{
    root: defaults.root,
    ...classNames,
  }} components={{
    Chevron: ({ className, orientation }) => {
      const Icon = orientation === "left" ? ChevronLeft : orientation === "right" ? ChevronRight : ChevronDown
      return <Icon className={cn("size-4", className)} />
    },
    DayButton: CalendarDayButton,
    Dropdown: CalendarDropdown,
    ...components,
  }} {...props} />
}
function CalendarDropdown(props: DropdownProps) {
  const { options, ...selectProps } = props;
  delete (selectProps as Partial<DropdownProps>).classNames;
  delete (selectProps as Partial<DropdownProps>).components;
  return <FieldSelect {...selectProps} icon={false} className={styles.navigationSelect}>{options?.map(option => <option key={option.value} value={option.value} disabled={option.disabled}>{option.label}</option>)}</FieldSelect>;
}

function CalendarDayButton({ className, day, modifiers, ...props }: React.ComponentProps<typeof DayButton>) {
  const ref = React.useRef<HTMLButtonElement>(null)
  React.useEffect(() => { if (modifiers.focused) ref.current?.focus({ preventScroll: true }) }, [modifiers.focused])
  return <Button ref={ref} variant="ghost" size="icon" data-day={day.date.toLocaleDateString()} data-calendar-date={`${String(day.date.getFullYear()).padStart(4, '0')}-${String(day.date.getMonth() + 1).padStart(2, '0')}-${String(day.date.getDate()).padStart(2, '0')}`} data-selected={modifiers.selected} data-range-middle={modifiers.range_middle} className={cn(styles.dayButton, className)} {...props} />
}

export { Calendar, CalendarDayButton }
